/* Animation Controller

1) Provides unified requestAnimationFrame ticker
2) Separates read / write operations via update() and render() callbacks
	- update() will call render() only if update() returns true
*/

class AnimationController {

	beziers = {
		easeIn:	[0.490, 0.025, 0.650, 0.650],
		easeOut: [0.280, 0.440, 0.490, 1.000],
		easeInOut: [0.490, 0.025, 0.490, 1.000],
		easeInSoft: [0.490, 0.025, 0.685, 1.000],
		easeOutSoft: [0.280, 0.000, 0.490, 1.000],
		easeInOutSoft: [0.720, 0.000, 0.280, 1.000],
		easeOutJim: [0.420, 0.000, 0.002, 1.000],
		easeOutJimFast: [0.240, 0.002, 0.002, 1.000],
		easeOutJimDynamic: [0.000, 0.000, 0.002, 1.000]
	};

	frame; // requestAnimationFrame callback method

	subscribers = []; // objects assigned via set() or one() subscribed to update() & render()

	loop() {
		this.frame = requestAnimationFrame(() => this.loop());
		this.update();
		this.render();
	}

	// update (read cycle)

	update() {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const animation = this.subscribers[i];
			if (animation && animation.update()) animation.updated = true;
		}
	}

	// render (write cycle)

	render() {
		for (let i = 0, l = this.subscribers.length; i < l; ++i) {
			const animation = this.subscribers[i];
			if (animation && animation.updated) {
				animation.updated = false;
				animation.render();
				if (animation.die) this.clear(i);
			}
		}
	}

	// start / stop animation loop

	start() {
		this.loop();
	}

	stop() {
		cancelAnimationFrame(this.frame);
		this.frame = null;
	}

	// add / remove subscribers

	set(obj) {
		obj.updated = false;
		this.subscribers.push(obj);
		return this.subscribers.length - 1;
	}

	clear(index) {
		this.subscribers[index] = null;
	}

	// subscribe new object for only one tick cycle

	one(obj) {
		const index = this.set(obj);
		this.subscribers[index].die = true;
	}

}

export default new AnimationController();
